import script from "./Redirect.vue?vue&type=script&setup=true&lang=js"
export * from "./Redirect.vue?vue&type=script&setup=true&lang=js"

import "./Redirect.vue?vue&type=style&index=0&id=707a86f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-707a86f8"]])

export default __exports__